/**
 * Vérifie si un élément a une class
 */
export function elementHasClass(classes: string, name: string): boolean {
    if (typeof classes == "undefined" || classes == "") {
        return false;
    }

    return !!classes.match(new RegExp('(\\s|^)' + name + '(\\s|$)'));
}